import { defineComponent as _defineComponent } from 'vue'

/* Expandable description
 * Show the first part of the description -> click to view full description. Strategy uses line-clamp
 * so all the text is available for SEO
 *
 */

export interface UserAgent {
  $ua: {
    browser(): string;
    deviceType(): string;
    engine(): string;
    os(): string;
    platform(): string;
    source(): string;
  };
}

declare module '@nuxt/types' {
  interface Context extends UserAgent {}
}

const __default__ = {
  name: 'ExpandableDescription',
};

import { ref, onMounted, computed, useContext } from '@nuxtjs/composition-api';
import { wpautop } from '~/utils/html';

export interface ExpandableDescriptionProps {
  description?: string;
  lineClamp?: 1 | 2 | 3 | 4 | 5 | 'none';
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    description: { default: '' },
    lineClamp: { default: 5 }
  },
  setup(__props: any) {

const props = __props as { description: string, lineClamp: 1 | 2 | 3 | 4 | 5 | 'none' };

const { $ua } = useContext();


const expandDescription = ref(false);
const expansionNotRequired = ref(true);
const textRef = ref<HTMLSpanElement | null>(null);
const isSafari = computed(() => {
  const ua = $ua.browser().toLowerCase();
  return ua.includes('safari') && !ua.includes('chrome');
});
const transformedDescription = computed(() => {
  // Wraps paragraphs in <p> tags and does some other tidy up
  return wpautop(props.description);
});
const isClamped = (element: HTMLElement): boolean => {
  if (isSafari.value) {
    // HACK: Safari does not correctly handle clamping so we use a hack to
    // hide all but the first paragraph.  We will assume then if there is more than
    // 1 child that the content is clamped.
    return (
      element.querySelector(
        '.tw-line-clamp-1,.tw-line-clamp-2,.tw-line-clamp-3,tw-line-clamp-4,.tw-line-clamp-5 > :not(:first-child)'
      ) != null
    );
  }
  return element.clientHeight < element.scrollHeight;
};

onMounted(() => {
  if (textRef.value) {
    expandDescription.value = expansionNotRequired.value =
      props.lineClamp === 'none' || !isClamped(textRef.value);
  }
});

return { __sfc: true,$ua, props, expandDescription, expansionNotRequired, textRef, isSafari, transformedDescription, isClamped }
}

})